import React from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { collapseDoubledSportsPath } from '@/util/seoCanonicalUrl'

/**
 * `/markets/sports/sports/...` repeats the sports segment. Google needs the
 * server 301 in `server.js`; this covers in-app navigation to the same path.
 */
const DoubledSportsRedirect = () => {
  const location = useLocation()
  const target = collapseDoubledSportsPath(location.pathname) || '/markets/sports'
  return <Navigate to={`${target}${location.search}${location.hash}`} replace />
}

export default DoubledSportsRedirect
